import Pusher from 'pusher-js';

const Wss = (() => {
  let instance: Pusher;
  function createInstance(): Pusher {
    return new Pusher(`${process.env.REACT_APP_SOCKET_CHANNEL}`, {
      wsHost: `${process.env.REACT_APP_SOCKET_HOST}`,
      wsPort: Number(process.env.REACT_APP_SOCKET_PORT),
      wssPort: Number(process.env.REACT_APP_SOCKET_PORT),
      forceTLS: false,
      cluster: 'mt1',
      disableStats: true,
      enabledTransports: ['ws', 'wss'],
    });
  }
  return {
    getInstance() {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    },
    connect() {
      if (!instance) {
        instance = createInstance();
      }
    },
  };
})();

export default Wss;
